export default "__VITE_ASSET__CweTLeDm__"